import { X } from 'lucide-react';
import React, { useEffect } from 'react'

interface IDrawerProps{
isOpen: boolean;
onClose: () => void;
children: React.ReactNode;
}

const Drawer:React.FC <IDrawerProps> = ({isOpen, onClose, children}) => {
  return (
    isOpen ?
        <div className="popupWrap">
        <div className="drawerWrap">
                <button className="closePopup" onClick={onClose}>
                    <X size={24}/>
                </button>
                <div className="drawerCont">
                    {children}
                </div>
            </div>
        </div>
        : null
  )
}

export default Drawer